export enum WorkflowType {
	INTAKE_QUESTIONS = 'intake_questions_workflows',
	CALL_WEBHOOK = 'call_webhook_workflows',
	CALENDAR = 'calendar_workflow',
}

export enum ScenarioProperty {
	CUSTOM_SCENARIO = 'customScenario',
	SCENARIO = 'scenario',
	DESCRIPTION = 'description',
}

export enum IntakeDescriptionType {
	CUSTOM_SCENARIO = 'custom-scenario',
	BEGINNING = 'beginning',
}
